module.exports = __webpack_public_path__ + "assets/cover_3_old.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/cover_3_old.jpg
 ** module id = 208
 ** module chunks = 1
 **/